/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { Table, Typography, TableRow, TableHead, TableContainer, TableBody, TableCell, Button, Checkbox } from '@material-ui/core';
import * as Ledger from '../model/Ledger';
import * as Player from '../model/Player';

export interface LedgerViewProps {
    player: Player.Model;
    ledger: Ledger.Model;
    setLedger: Function;
}

export const LedgerView = (props: LedgerViewProps) => {
    const [selected, setSelected] = React.useState<number[]>([]);

    const handleReversal = () => {
        props.setLedger(Ledger.reverseSet(props.ledger, selected));
        setSelected([]);
    }

    const onSelectAllClick = () => {
        if(selected.length !== props.ledger.lineItems.length) {
            setSelected(props.ledger.lineItems.map((item, index) => {
                return index;
            }));
        } else {
            setSelected([]);
        }
    };

    let ledger = (
        <TableRow>
            <TableCell colSpan={3}><i>No damage</i></TableCell>
        </TableRow>
    );

    if(props.ledger.lineItems.length != null && props.ledger.lineItems.length > 0) {
        ledger = (
            <React.Fragment>
                {props.ledger.lineItems.map((lineItem: Ledger.Entry, index: number) => {
                    const isItemSelected: boolean = (selected.indexOf(index) !== -1);

                    const toggleSelectedItem = (event: React.ChangeEvent<HTMLInputElement>) => {
                        const value: number = Number(event.currentTarget.value);
                        const selectedItemIndex: number = selected.indexOf(value);
                        const itemNotSelected: boolean = selectedItemIndex === -1;
                        let newSelected: number[] = [];

                        if(itemNotSelected) {
                            newSelected = selected.concat(selected, value);
                        } else if(selectedItemIndex === 0) {
                            newSelected = selected.slice(1);
                        } else if(selectedItemIndex === selected.length - 1) { 
                            newSelected = selected.slice(0, -1);
                        } else if(selectedItemIndex > 0) {
                            newSelected = selected.concat(selected.slice(0, selectedItemIndex), selected.slice(selectedItemIndex + 1))
                        }

                        setSelected(newSelected);
                    }
                

                    return (
                        <TableRow key={index}>
                            <TableCell padding={"checkbox"} >
                                <Checkbox value={index} checked={isItemSelected} onChange={toggleSelectedItem} />
                            </TableCell>    
                            <TableCell>
                                {lineItem.damage}
                            </TableCell>
                            <TableCell>
                                {lineItem.type}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            <Typography variant="h5">Damage Against {props.player.name}</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell padding={"checkbox"}><Checkbox onChange={onSelectAllClick} /></TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Type</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ledger}
                    </TableBody>                     
                </Table>
            </TableContainer>
            <Button color="primary" onClick={handleReversal}>
                Reverse damage
            </Button>
        </React.Fragment>
    );
}
